export default __webpack_public_path__ + "static/media/azuki.1ea42e5e.png";